let key = {};
if (process.env.NODE_ENV === "production") {
  console.log("Set Production Config");
  const API_URL         = 'https://spideynftapi.wealwin.com/v2';
  const frontUrl        = 'https://spidey-nft-adminpanel.pages.dev/';
  const Nfturl          = "https://spidey-nft-frontend.pages.dev/";
  const ContractAddress = "0x581A1C7BE1e2D0C77905Bdf77B2EB0f067B19f1f";
  const adminAddress = "0x3778EcF0b729ecd4DdcA96e2D9f588314Ad73F6D";

  // const API_URL = "https://api.spideybarter.com/v2";
  // const frontUrl = "https://spideybarter.com/spideyadmin";
  // const Nfturl = "https://spideybarter.com/SpideyBarter-NFT/info/";
  // const ContractAddress = "0x4Eb4FAa37167d21244aA6D8F3c3F1F7736688E6D";

  key = {
    secretOrKey: "",
    Recaptchakey: "",
    frontUrl: frontUrl,
    Nfturl: Nfturl,
    API: `${API_URL}`,
    ContractAddress: ContractAddress,
    adminAddress: adminAddress,
  };
} else {
  console.log("Set Development Config");
  const API_URL = "http://localhost:2056/v2";
  const frontUrl = "http://localhost:3000";
  const Nfturl = "https://spideybarter.com/SpideyBarter-NFT/info/";
  const ContractAddress = "0x581A1C7BE1e2D0C77905Bdf77B2EB0f067B19f1f";
  const adminAddress = "0x3778EcF0b729ecd4DdcA96e2D9f588314Ad73F6D";
  key = {
    secretOrKey: "",
    Recaptchakey: "",
    Nfturl: Nfturl,
    frontUrl: frontUrl,
    // API:`${API_URL}:2086`,
    API: `${API_URL}`,
    ContractAddress: ContractAddress,
    adminAddress: adminAddress,
  };
}

export default key;

//old
// let key = {};
// if (process.env.NODE_ENV === "production") {
//   console.log("Set Production Config");
//   // const API_URL = 'http://212.71.233.123';
//   // const frontUrl = 'http://212.71.233.123/spideywqwedkk';

//   const API_URL = "https://api.spideybarter.com/v2";
//   const frontUrl = "https://spideybarter.com/spideyadmin";
//   const ContractAddress = "0xB0633070cFf8014a959Cc512DCBbfCf97FcEF739";

//   key = {
//     secretOrKey: "",
//     Recaptchakey: "",
//     frontUrl: frontUrl,
//     Nfturl:Nfturl,
//     API: `${API_URL}`,
//     ContractAddress: ContractAddress,
//   };
// } else {
//   console.log("Set Development Config");
//   const API_URL = "http://localhost:2056/v2";
//   const frontUrl = "http://localhost:3000";
//   const ContractAddress = "0xB0633070cFf8014a959Cc512DCBbfCf97FcEF739";
//   key = {
//     secretOrKey: "",
//     Recaptchakey: "",
//     Nfturl:Nfturl,
//     frontUrl: frontUrl,
//     // API:`${API_URL}:2086`,
//     API: `${API_URL}`,
//     ContractAddress: ContractAddress,
//   };
// }

// export default key;
